// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import PathSummaryHeader from './PathSummaryHeader'

// because of how the <DataTable />'s header is fixed,
// and to avoid having to override a bunch of CSS,
// the 'band' heading is instead placed relative to 'Site Name'

class SiteNameHeader extends PathSummaryHeader {
  sortByBand = e => this.assignSort(e, 'band')

  bandStyles = {
    position: 'absolute',
    right: '100%',
  }

  render () {
    const {
      bandStyles,
      props: { idRoot },
      sortByBand,
      sortIcon,
    } = this

    return (
      <div className={'display-flex'}>
        <span
          className={'padding-right-1 pointer'}
          id={`${idRoot}path-band`}
          style={bandStyles}
          onClick={sortByBand}>
          {'Band'}
          {sortIcon('band')}
        </span>
        <span id={`${idRoot}heading`}>{'Site Name'}</span>
      </div>
    )
  }
}

export default SiteNameHeader
